export default function pluralizeWord(amount, singular, plural = null) {
    return Math.abs(parseInt(amount)) === 1 ? singular : plural || `${singular}s`;
}
